<div class="page-shell">
  <mat-toolbar class="header">
    <button
      mat-icon-button
      type="button"
      routerLink="/card-orders"
      [attr.aria-label]="'cancel' | translate"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>{{
      order?.printCardOrderId
        ? ("cardOrders.detailTitle" | translate) +
          ": " +
          order.printCardOrderId
        : ("cardOrders.detailTitle" | translate)
    }}</span>
  </mat-toolbar>

<div class="detail-wrapper">
  <div class="detail-layout" *ngIf="order">
    <aside
      class="detail-sidebar"
      *ngIf="visibleFulfillmentSteps.length"
    >
      <section class="fulfillment-section card-panel">
        <div class="fulfillment-header">
          <h2>{{ "printCardOrders.fulfillment.title" | translate }}</h2>
          <span class="stage-badge" [attr.data-stage]="order.status">
            {{ getFulfillmentStageLabelKey(order.status) | translate }}
          </span>
        </div>

        <ol class="fulfillment-timeline">
          <li
            *ngFor="let step of visibleFulfillmentSteps"
            class="fulfillment-step"
            [class.completed]="step.state === 'completed'"
            [class.current]="step.state === 'current'"
            [class.cancelled]="step.state === 'cancelled'"
          >
            <div class="fulfillment-step-marker" aria-hidden="true">
              <mat-icon *ngIf="step.state === 'completed'">check</mat-icon>
              <mat-icon *ngIf="step.state === 'current'">radio_button_checked</mat-icon>
              <mat-icon *ngIf="step.state === 'cancelled'">close</mat-icon>
            </div>
            <div class="fulfillment-step-content">
              <div class="fulfillment-step-title">
                {{ getFulfillmentStageLabelKey(step.id) | translate }}
              </div>
              <div class="fulfillment-step-meta" *ngIf="step.occurredAt">
                {{ step.occurredAt | localizedDate : "medium" }}
              </div>
              <div class="fulfillment-step-detail" *ngIf="step.detail">{{ step.detail }}</div>
            </div>
          </li>
        </ol>
      </section>
    </aside>

    <div class="detail-main">
  <section
    class="order-action-section card-panel"
    *ngIf="canApproveOrder || canCancelOrder"
  >
    <div class="order-action-header">
      <div class="order-action-title">
        <h2>
          {{
            (canApproveOrder
              ? "cardOrders.approveOrderSectionTitle"
              : "cardOrders.cancelOrderSectionTitle"
            ) | translate
          }}
        </h2>
        <p class="order-action-description">
          {{
            (canApproveOrder
              ? "cardOrders.approveOrderSectionBody"
              : "cardOrders.cancelOrderSectionBody"
            ) | translate
          }}
        </p>
      </div>
      <div class="order-action-status">
        <mat-icon class="status-icon idle">
          {{ canApproveOrder ? "assignment_turned_in" : "block" }}
        </mat-icon>
      </div>
    </div>

    <div class="order-action-actions">
      <button
        mat-flat-button
        color="primary"
        type="button"
        *ngIf="canApproveOrder"
        (click)="approveOrder()"
        [disabled]="approveLoading || cancelLoading"
      >
        <mat-spinner
          diameter="20"
          class="dc-btn-spinner"
          *ngIf="approveLoading"
        ></mat-spinner>
        <mat-icon *ngIf="!approveLoading">assignment_turned_in</mat-icon>
        {{ "cardOrders.approveOrderConfirm" | translate }}
      </button>
      <button
        mat-stroked-button
        color="warn"
        type="button"
        *ngIf="canCancelOrder"
        (click)="cancelOrder()"
        [disabled]="cancelLoading || approveLoading"
      >
        <mat-spinner class="dc-btn-spinner" diameter="20" *ngIf="cancelLoading"></mat-spinner>
        <mat-icon *ngIf="!cancelLoading">block</mat-icon>
        {{ "cardOrders.cancelOrderConfirm" | translate }}
      </button>
    </div>
  </section>

  <section class="info-section card-panel">
    <h2>{{ "printCardOrders.orderInfo" | translate }}</h2>
    <div class="info-grid">
      <div>
        <span class="label">{{ "printCardOrders.orderId" | translate }}</span>
        <span>{{ order.printCardOrderId }}</span>
      </div>
      <div>
        <span class="label">{{ "printCardOrders.employee" | translate }}</span>
        <span *ngIf="order.recipients?.length <= 1">
          {{ order.employeeName || order.employeeEmail }}
        </span>
        <span *ngIf="order.recipients?.length > 1">
          {{ "printCardOrders.groupRecipientsCount" | translate : { count: order.recipients.length } }}
        </span>
      </div>
      <div>
        <span class="label">{{ "cardOrders.placedBy" | translate }}</span>
        <span>{{ order.placedByName || order.placedByEmail }}</span>
      </div>
      <div *ngIf="order.createdAt">
        <span class="label">{{ "printCardOrders.createdAt" | translate }}</span>
        <span>{{ order.createdAt | localizedDate : "medium" }}</span>
      </div>
      <div *ngIf="order.deliveryType">
        <span class="label">{{ "printCardOrders.deliveryType" | translate }}</span>
        <span>{{ getShipmentMethodLabelKey(order.deliveryType) | translate }}</span>
      </div>
      <div *ngIf="order.deliverySpeed">
        <span class="label">{{ "printCardOrders.deliverySpeed" | translate }}</span>
        <span>{{ getDeliverySpeedLabelKey(order.deliverySpeed) | translate }}</span>
      </div>
      <div *ngIf="order.deliveryType !== 'PICKUP' && order.shipmentCarrier">
        <span class="label">{{ "printCardOrders.shipmentCarrier" | translate }}</span>
        <span *ngIf="order.shipmentCarrier !== 'OTHER'">{{
          getShipmentCarrierLabelKey(order.shipmentCarrier) | translate
        }}</span>
        <span *ngIf="order.shipmentCarrier === 'OTHER'">{{
          order.externalShipment?.carrierName ||
            ("printCardOrders.shipmentCarrierOther" | translate)
        }}</span>
      </div>
      <div *ngIf="order.recipientName">
        <span class="label">{{ "printCardOrders.recipientName" | translate }}</span>
        <span>{{ order.recipientName }}</span>
      </div>
      <div *ngIf="order.companyName">
        <span class="label">{{ "printCardOrders.companyName" | translate }}</span>
        <span>{{ order.companyName }}</span>
      </div>
      <div *ngIf="order.phone">
        <span class="label">{{ "printCardOrders.phone" | translate }}</span>
        <span>{{ order.phone }}</span>
      </div>
      <div
        *ngIf="order.deliveryType !== 'PICKUP' && order.shippingAddress?.line1"
        class="full-width-info"
      >
        <span class="label">{{ "printCardOrders.shippingAddress" | translate }}</span>
        <span class="address-lines">
          <span
            class="address-line"
            *ngFor="let line of formatShippingAddressLines(order.shippingAddress)"
          >
            {{ line }}
          </span>
          <span
            class="country-address-label address-country"
            *ngIf="order.shippingAddress.country?.trim() as countryCode"
          >
            <img
              class="country-select-flag"
              [src]="getCountryFlagUrl(countryCode)"
              width="20"
              height="15"
              alt=""
            />
            {{ getCountryDisplayName(countryCode) }}
          </span>
        </span>
      </div>
      <div
        *ngIf="order.deliveryType === 'ACCESS_POINT' && order.upsAccessPoint as accessPoint"
        class="full-width-info"
      >
        <span class="label">{{ "printCardOrders.accessPoint" | translate }}</span>
        <span class="access-point-detail">
          <span>
            {{ formatUpsAccessPointName(accessPoint.name) }},
            {{ formatUpsAccessPointAddress(accessPoint) }}
          </span>
          <span
            class="access-point-detail__hours"
            *ngIf="formatUpsAccessPointOpeningHours(accessPoint.openingHours) as openingHours"
          >
            <span class="access-point-detail__hours-label">
              {{ "cardOrders.accessPointOpeningHoursLabel" | translate }}
            </span>
            {{ openingHours }}
          </span>
        </span>
      </div>
      <div *ngIf="order.notes?.trim()" class="full-width-info">
        <span class="label">{{ "printCardOrders.orderNotes" | translate }}</span>
        <span class="order-notes-text">{{ order.notes }}</span>
      </div>
    </div>

    <h3>{{ "printCardOrders.items" | translate }}</h3>
    <app-order-items-list
      *ngIf="order.recipients?.length"
      [recipients]="order.recipients"
      [showPreviewActions]="true"
      [orderId]="order.printCardOrderId"
    ></app-order-items-list>
  </section>

  <section class="fulfillment-section card-panel" *ngIf="hasExternalShipment && order.externalShipment">
    <h3>{{ "printCardOrders.externalShipmentTitle" | translate }}</h3>
    <div class="info-grid">
      <div>
        <span class="label">{{ "printCardOrders.shipmentCarrier" | translate }}</span>
        <span>{{ order.externalShipment.carrierName }}</span>
      </div>
      <div>
        <span class="label">{{ "printCardOrders.trackingNumber" | translate }}</span>
        <span>{{ order.externalShipment.trackingNumber }}</span>
      </div>
      <div *ngIf="order.externalShipment.trackingUrl">
        <span class="label">{{ "printCardOrders.externalShipmentTrackingLink" | translate }}</span>
        <a
          [href]="order.externalShipment.trackingUrl"
          target="_blank"
          rel="noopener noreferrer"
          >{{ order.externalShipment.trackingUrl }}</a
        >
      </div>
    </div>
  </section>

  <section class="fulfillment-section card-panel" *ngIf="hasUpsTracking && !hasExternalShipment">
    <app-ups-packages-tracking
      *ngIf="orderUpsPackages.length"
      [packages]="orderUpsPackages"
      [shipmentDescription]="orderUpsShipmentDescription"
      [shipmentCarrier]="order.shipmentCarrier"
    ></app-ups-packages-tracking>

    <app-ups-tracking-timeline
      *ngIf="!orderUpsPackages.length"
      [trackingNumber]="upsTrackingNumber"
      [status]="upsTrackingStatus"
      [activities]="upsTrackingActivities"
      [delivered]="isUpsDelivered"
      [shipmentDescription]="orderUpsShipmentDescription"
      [shipmentCarrier]="order.shipmentCarrier"
      [collapsibleHistory]="true"
    ></app-ups-tracking-timeline>
  </section>

    </div>
  </div>
</div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="loading">
    <app-loading></app-loading>
  </div>
</div>
